/**
 * AR Vision Demo — registry entry.
 *
 * THROWAWAY DEMO CODE. Side-effecting registration (imported once from
 * `@/demo/init`) so the shared `<DemoStoreProvider>` / `<DemoControls>` can
 * resolve the AR demo when `?demo=ar` is active.
 */

import { registerDemo } from '@/demo/core/demo-registry';
import { ArDemoStoreProvider, resetArDemoState } from './fixture-store';
import { resetVoiceCall } from './voice-call-store';

registerDemo({
  key: 'ar',
  label: 'AR Demo Mode',
  accent: {
    badge: 'border-purple-200',
    label: 'text-purple-700',
    resetButton: 'bg-purple-600 hover:bg-purple-700',
  },
  reset: () => {
    resetArDemoState();
    resetVoiceCall();
  },
  StoreProvider: ArDemoStoreProvider,
});
